import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Filters from "../components/Filters";
import AttendanceTable from "../components/AttendanceTable";
import axios from "axios";
import { BACKEND_URL } from "../data/config";

const AttendancePage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    month: "",
    search: ""
  });

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    pages: 0
  });

  const loadData = async (page = 1) => {
    setLoading(true);

    try {
      const params = new URLSearchParams({
        month: filters.month,
        search: filters.search,
        page: page.toString()
      });

      const response = await axios.get(
        `${BACKEND_URL}/api/attendance-list.php?${params}`
      );

      if (response.data.success) {
        setData(response.data.data);

        setPagination({
          page: response.data.pagination?.page || 1,
          limit: response.data.pagination?.limit || 10,
          total: response.data.pagination?.total || 0,
          pages: response.data.pagination?.pages || 1
        });
      }
    } catch (error) {
      console.error("Loading error:", error);
      setData([]);
      setPagination({ page: 1, limit: 10, total: 0, pages: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const currentMonth = new Date().toISOString().slice(0, 7);
    setFilters((prev) => ({ ...prev, month: currentMonth }));
  }, []);

  useEffect(() => {
    if (filters.month) {
      loadData(1);
    }
  }, [filters.month, filters.search]);

  const handleFilterChange = (month) => {
    setFilters((prev) => ({ ...prev, month }));
  };

  const handleSearch = (e) => {
    setFilters((prev) => ({
      ...prev,
      search: e.target.value
    }));
  };

  const handlePageChange = (page) => {
    loadData(page);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />

      <div className="max-w-6xl mx-auto p-6">

        {/* HEADER */}

        <div className="mb-6">

          <h1 className="text-2xl font-semibold text-gray-900">
            Attendance Records
          </h1>

          <p className="text-sm text-gray-500 mt-1">
            Month:{" "}
            {filters.month
              ? new Date(filters.month + "-01").toLocaleDateString(
                "en-US",
                { year: "numeric", month: "long" }
              )
              : "Loading..."}
          </p>

        </div>

        {/* MONTH FILTER */}

        <Filters onFilterChange={handleFilterChange} />

        {/* SEARCH */}

        <div className="mt-6 mb-6">

          <input
            type="text"
            placeholder="Search employee, date..."
            value={filters.search}
            onChange={handleSearch}
            className="w-full md:w-80 border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

        </div>

        {/* TABLE */}

        <AttendanceTable data={data} loading={loading} />

        {/* PAGINATION */}

        {pagination.pages > 1 && (

          <div className="flex justify-between items-center mt-6 text-sm">

            <div className="text-gray-500">
              {pagination.total} records
            </div>

            <div className="flex gap-2">

              <button
                onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page === 1}
                className="px-3 py-1 border rounded disabled:opacity-40"
              >
                Previous
              </button>

              <span className="px-3 py-1">
                Page {pagination.page} / {pagination.pages}
              </span>

              <button
                onClick={() => handlePageChange(pagination.page + 1)}
                disabled={pagination.page === pagination.pages}
                className="px-3 py-1 border rounded disabled:opacity-40"
              >
                Next
              </button>

            </div>

          </div>

        )}

      </div>
    </div>
  );
};

export default AttendancePage;